'use client';

import { NotFoundMessage } from '@/components/NotFoundMessage';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation'
import ButtonCustom from '@/components/Buttons/ButtonCustom/ButtonCustom';

export default function Error({
    error,
    reset,
}: {
    error: Error;
    reset: () => void;
}) {
    const router = useRouter();

    useEffect(() => {
        console.error('[Error Client]', error);
    }, [error]);

    return (
        <div className='flex flex-col items-center justify-center w-full h-[calc(100vh-160px)]'>

            <div className='flex flex-col gap-4'>
                <NotFoundMessage
                    classNameIcon='text-[--primary-color]'
                    classNameSubtitle='text-[--text-color]'
                    sizeIcon='large'
                    icon='handyman'
                    title='Ops! Algo deu errado'
                    subtitle='Por favor, entre em contato com o suporte ou tente acessar novamente!'
                />

                <div className='flex gap-4'>
                    <ButtonCustom
                        label='Voltar para início'
                        onClick={() => router.back()}
                    />

                    <ButtonCustom
                        className='cancel'
                        label='Tentar novamente'
                        onClick={() => router.back()}
                    />
                </div>
            </div>
        </div>
    );
}
